<template>
  <SectionCard :id="section.id" :title="section.title">
    <AppTable>
      <thead>
        <tr>
          <th>Låntagare</th>
          <th>Status</th>
          <th>Länk till lånehandlingar</th>
        </tr>
      </thead>
      <tbody>
        <AppTableRow v-for="agreement in application.depositLoanAgreements ?? []" :key="agreement.url">
          <AppTableCell>{{ documentUser(agreement.userId) }}</AppTableCell>
          <AppTableCell>{{ agreement.status ?? '-' }}</AppTableCell>
          <AppTableCell>
            <a
              :href="agreement.url"
              target="_blank"
              rel="noopener noreferrer"
              class="font-medium text-sky-700 hover:text-sky-900 hover:underline"
            >
              Öppna
            </a>
          </AppTableCell>
        </AppTableRow>
      </tbody>
    </AppTable>
  </SectionCard>
</template>

<script setup lang="ts">
import { AppTable, AppTableCell, AppTableRow, SectionCard } from '@staff/ui'
import { getFullName } from '@/utils/applicationDisplay'
import { useRequiredApplication } from '@/views/application/application.context'
import type { ApplicationSections } from './sections'

defineProps<{
  section: ApplicationSections['depositLoanAgreements']
}>()

const application = useRequiredApplication()

const documentUser = (documentUserId: string) => {
  const applicant = application.value.applicants.find((item) => item.userId === documentUserId)
  return applicant ? getFullName(applicant) : '-'
}
</script>
